<div class="wrap">
  <button class="toggler" (click)="onToggle()">DEBUG</button>
  <div *ngIf="!isMinimized" class="body">
    <button (click)="onCreateAuthData()">Create Auth Data</button>
    <button (click)="onLogout()">Logout</button>
    <button (click)="onExpireToken()">Expire token</button>
  </div>
</div>
